import { render, staticRenderFns } from "./MatterSmugglingForm.vue?vue&type=template&id=5e6e9936&"
import script from "./MatterSmugglingForm.vue?vue&type=script&lang=js&"
export * from "./MatterSmugglingForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterSmugglingForm.vue?vue&type=style&index=0&id=5e6e9936&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports